import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { SecurityService } from './security.service';

@Directive({
  selector: '[accessFormField]',
  standalone: false,
})
export class AccessFormFieldDirective implements OnInit {
  constructor(
    private readonly security: SecurityService,
    private readonly control: FormControlName,
  ) {}

  @Input('accessFormField') permissions: string[] = [];

  @HostBinding('class.access-denied')
  get classBaseOnPermissions(): boolean {
    return this.checkAccess(this.permissions);
  }

  ngOnInit(): void {
    if (this.checkAccess(this.permissions)) {
      const valueAccessor = this.control.valueAccessor;
      if (valueAccessor?.setDisabledState) {
        valueAccessor.setDisabledState(true);
      } else if ((valueAccessor as any).hasOwnProperty('readonly')) {
        (valueAccessor as any).readonly = true;
      } else if ((valueAccessor as any).hasOwnProperty('disabled')) {
        (valueAccessor as any).disabled = true;
      }
    }
  }

  private checkAccess(permissions: string[]): boolean {
    return !this.security.hasAccess(permissions);
  }
}
